import { render, staticRenderFns } from "./RoServiceOpCodeSelector.vue?vue&type=template&id=672f6017&scoped=true"
import script from "./RoServiceOpCodeSelector.vue?vue&type=script&lang=js"
export * from "./RoServiceOpCodeSelector.vue?vue&type=script&lang=js"
import "./RoServiceOpCodeSelector.vue?vue&type=style&index=0&id=672f6017&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672f6017",
  null
  
)

export default component.exports